import type { Metric } from './types';

export function render({ name, labels, value }: Metric): string {
  const formattedLabels = Object.entries(labels)
    .map(([key, val]) => `${key}="${val}"`)
    .join(', ');
  const body = `${name}{${formattedLabels}} ${value ?? 1}`;
  return body;
}

export function renderMany(metrics: Metric[]): string {
  return metrics.map(render).concat('').join('\n');
}
